import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import {
  ICommerceUserForm,
  COMMERCE_FORM_OPTIONS,
  COMMERCE_FORM_STEPS,
} from 'src/app/pages/core/models/Commerce';
import errors from 'src/app/pages/core/utils/errorCodes';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-commerce-onboarding',
  templateUrl: './commerce-onboarding.component.html',
  styleUrls: ['./commerce-onboarding.component.scss'],
})
export class CommerceOnboardingComponent implements OnInit {
  formStep: COMMERCE_FORM_STEPS = COMMERCE_FORM_STEPS.TYPE;
  actualStep = 0;
  sessionSteps: COMMERCE_FORM_STEPS[] = [];
  selectedOptions: ICommerceUserForm;
  commerceNameControl = new FormControl('', [Validators.required]);
  urlControl = new FormControl('', [Validators.required]);
  formCompleted = false;
  minItemShowed = 0;
  maxItemShowed = 6;
  screenNumber = 1;
  COMMERCE_FORM_STEPS = COMMERCE_FORM_STEPS;
  typeSelected;

  controlNames = {
    commerceName: this.commerceNameControl,
    url: this.urlControl,
  };

  stepsTitles = {
    type: '¿Pará qué tipo de negocio?',
    integration: '¿Qué e-commerce utilizás?',
    paymentGateway: '¿Cómo procesás pagos actualmente?',
    form: 'Tus datos',
    billingType: 'Último paso',
    thanks: '¡Listo!',
  };

  stepsSubtitles = {
    type: 'Seleccioná el tipo de negocio para el que te gustaría integrar API Commerce',
    integration: 'Seleccioná el market place que usás para tu comercio',
    paymentGateway: 'Integración manual',
    form: 'Por favor ingrese los datos',
    billingType: '¿Querés utilizar la cuenta actual o crear una cuenta de empresa?',
    thanks:
      'Te redirigimos al register para que puedas crear una cuenta de empresa y comenzar a cobrar con nosotros.',
  };

  options = {
    type: [
      { name: 'Ecommerce', key: COMMERCE_FORM_OPTIONS.ECOMMERCE },
      { name: 'Tienda Física', key: COMMERCE_FORM_OPTIONS.SHOP },
    ],
    integration: [
      { name: 'Tienda Nube', key: COMMERCE_FORM_OPTIONS.TIENDANUBE },
      { name: 'Woocommerce', key: COMMERCE_FORM_OPTIONS.WOOCOMMERCE },
      { name: 'Empretienda', key: COMMERCE_FORM_OPTIONS.EMPRETIENDA },
      { name: 'Prestashop', key: COMMERCE_FORM_OPTIONS.PRESTASHOP },
      { name: 'Magento', key: COMMERCE_FORM_OPTIONS.MAGENTO },
      { name: 'Vtex', key: COMMERCE_FORM_OPTIONS.VTEX },
      { name: 'Wix', key: COMMERCE_FORM_OPTIONS.WIX },
      { name: 'Ecwid', key: COMMERCE_FORM_OPTIONS.ECWID },
      { name: 'Otros', key: COMMERCE_FORM_OPTIONS.OTHERS },
    ],
    billingType: [
      { name: 'Utilizo la actual', key: COMMERCE_FORM_OPTIONS.INDIVIDUAL },
      { name: 'Crear una empresa', key: COMMERCE_FORM_OPTIONS.COMPANY },
    ],
  };

  constructor(
    public dialogRef: MatDialogRef<CommerceOnboardingComponent>,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {}

  validForm() {
    this.urlControl.markAsTouched;
    this.commerceNameControl.markAsTouched;
    return this.urlControl.status && this.commerceNameControl.status;
  }

  handleOption(option: string) {
    this.actualStep++;
    if (this.formStep === COMMERCE_FORM_STEPS.TYPE) {
      this.sessionSteps = [];
      this.sessionSteps.push(this.formStep);
      if (option !== COMMERCE_FORM_OPTIONS.SHOP) {
        let handleOptions = {
          [COMMERCE_FORM_OPTIONS.ECOMMERCE]: () => {
            this.formStep = COMMERCE_FORM_STEPS.FORM;
            this.typeSelected = COMMERCE_FORM_STEPS.INTEGRATION;
            this.selectedOptions = {
              ...this.selectedOptions,
              type: COMMERCE_FORM_OPTIONS.ECOMMERCE.toUpperCase(),
            };
          },
        };
        handleOptions[option]();
      } else {
        this.formStep = COMMERCE_FORM_STEPS.FORM;
        this.typeSelected = COMMERCE_FORM_STEPS.FORM;
        this.selectedOptions = {
          ...this.selectedOptions,
          type: COMMERCE_FORM_OPTIONS.SHOP.toUpperCase(),
        };
        this.typeSelected = COMMERCE_FORM_STEPS.BILLINGTYPE;
        this.selectedOptions = { ...this.selectedOptions, type: COMMERCE_FORM_OPTIONS.SHOP.toUpperCase() };
      }
    } else if (this.formStep === COMMERCE_FORM_STEPS.FORM) {
      this.sessionSteps.push(this.formStep);
      if (this.validForm() === 'INVALID') return;
      this.selectedOptions = {
        ...this.selectedOptions,
        companyName: this.commerceNameControl.value,
      };
      this.selectedOptions = { ...this.selectedOptions, url: this.urlControl.value };
      this.formStep = this.typeSelected;
    } else if (this.formStep === COMMERCE_FORM_STEPS.INTEGRATION) {
      this.sessionSteps.push(this.formStep);
      this.selectedOptions = { ...this.selectedOptions, integration: option.toUpperCase() };
      this.formStep = COMMERCE_FORM_STEPS.BILLINGTYPE;
    } else if (this.formStep === COMMERCE_FORM_STEPS.BILLINGTYPE) {
      if (this.authService.isCompany()) {
        this.formStep = COMMERCE_FORM_STEPS.THANKS;
        this.sessionSteps.push(this.formStep);
        return;
      }
      let handleOptions = {
        [COMMERCE_FORM_OPTIONS.INDIVIDUAL]: () => {
          this.selectedOptions = {
            ...this.selectedOptions,
            billingType: COMMERCE_FORM_OPTIONS.INDIVIDUAL,
          };
          this.sendUserInfo();
        },
        [COMMERCE_FORM_OPTIONS.COMPANY]: () => {
          this.selectedOptions = {
            ...this.selectedOptions,
            billingType: COMMERCE_FORM_OPTIONS.COMPANY,
          };
          this.selectedOptions = {
            ...this.selectedOptions,
            name: this.authService.loggedUser.name,
          };
          this.selectedOptions = {
            ...this.selectedOptions,
            email: this.authService.loggedUser.email,
          };
          this.selectedOptions = {
            ...this.selectedOptions,
            phoneNumber: this.authService.loggedUser.phoneNumber,
          };
          let optionsQueryString = '';
          Object.keys(this.selectedOptions).forEach((option) => {
            if (!optionsQueryString) {
              optionsQueryString = `?${option}=${this.selectedOptions[option]}`;
            } else {
              optionsQueryString += `&${option}=${this.selectedOptions[option]}`;
            }
          });
          this.authService.logout();
          window.open(environment.appUrl + 'auth/register' + optionsQueryString, '_blank');
        },
      };
      handleOptions[option]();
      this.sessionSteps.push(this.formStep);
      this.formStep = COMMERCE_FORM_STEPS.THANKS;
    }
  }

  handleScreenChange(direction: string) {
    if (direction === 'NEXT') {
      this.screenNumber = 2;
      this.minItemShowed = 6;
      this.maxItemShowed = 12;
    } else if (direction === 'PREVIOUS') {
      this.screenNumber = 1;
      this.minItemShowed = 0;
      this.maxItemShowed = 6;
    }
  }

  getOptions(formStep: COMMERCE_FORM_STEPS) {
    if (formStep === COMMERCE_FORM_STEPS.INTEGRATION) {
      return this.options[formStep]?.slice(this.minItemShowed, this.maxItemShowed);
    }
    return this.options[formStep];
  }

  handleBackButton() {
    if (this.formStep === 'form') {
      delete this.selectedOptions?.url;
      delete this.selectedOptions?.companyName;
    } else {
      delete this.selectedOptions[this.formStep];
    }
    if (this.actualStep !== 0) this.actualStep = this.actualStep - 1;
    this.formStep = Array.from(new Set(this.sessionSteps))[this.actualStep];
  }

  sendUserInfo() {
    this.stepsSubtitles.thanks =
      'En breve serás contactado por alguien de nuestro equipo para activarte la cuenta de commerce.';
    this.authService.commerceOnboarding(this.selectedOptions).subscribe(() => {
      this.formCompleted = true;
    });
  }

  getErrorMessage(input: string) {
    const keys = Object.keys(this.controlNames[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }
}
